// Free Shipping Progress Bar - Dynamic Updates
// Subscribes to Dawn's cart update events and updates the progress bar

if (typeof window.FreeShippingBarUpdater === 'undefined') {
  window.FreeShippingBarUpdater = {
    lastFetchTime: 0,
    fetchDebounceMs: 1000, // Minimum 1 second between fetches
    updatePending: false,

    init() {
      // Subscribe to cart updates
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
      }

      // Watch for when the free shipping bar appears in DOM
      this.observeDOM();

      // Initial update
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.debouncedUpdate();
        });
      } else {
        this.debouncedUpdate();
      }
    },

    observeDOM() {
      let barExists = false;

      // Watch for the cart drawer being updated
      const observer = new MutationObserver((mutations) => {
        const barElement = document.querySelector('.cart-free-shipping');

        // Only update if the bar just appeared (wasn't there before)
        if (barElement && !barExists) {
          barExists = true;
          this.debouncedUpdate();
        } else if (!barElement && barExists) {
          barExists = false;
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Keep observer active longer to catch all cart updates
      setTimeout(() => observer.disconnect(), 30000);
    },

    // Debounced update to prevent rate limiting
    debouncedUpdate() {
      const now = Date.now();

      // If we've fetched recently, skip this request
      if (now - this.lastFetchTime < this.fetchDebounceMs) {
        // Schedule an update for later if one isn't already pending
        if (!this.updatePending) {
          this.updatePending = true;
          setTimeout(() => {
            this.updatePending = false;
            this.updateFromCurrentCart();
          }, this.fetchDebounceMs);
        }
        return;
      }

      this.updateFromCurrentCart();
    },

    async updateFromCurrentCart() {
      try {
        this.lastFetchTime = Date.now();
        const response = await fetch('/cart.js');

        if (!response.ok) {
          if (response.status === 429) {
            console.warn('[Free Shipping] Rate limited, waiting before retry');
            // Back off exponentially if rate limited
            this.fetchDebounceMs = Math.min(this.fetchDebounceMs * 2, 5000);
          }
          return;
        }

        const cartData = await response.json();
        this.updateBar(cartData);

        // Reset debounce time on success
        this.fetchDebounceMs = 1000;
      } catch (error) {
        console.error('Error fetching cart:', error);
      }
    },

    handleCartUpdate(event) {
      if (event && event.cartData) {
        // Use cart data from event - no need to fetch!
        this.updateBar(event.cartData);
        // Update last fetch time to prevent duplicate fetch
        this.lastFetchTime = Date.now();
      }
    },

    updateBar(cartData) {
      const barElement = document.querySelector('.cart-free-shipping');
      if (!barElement) return;

      const threshold = parseInt(barElement.dataset.threshold || '8000');
      const messageTemplate = barElement.dataset.message || 'Add __AMOUNT__ more for free shipping!';
      const progressTemplate = barElement.dataset.progress || '__PERCENTAGE__% complete';
      const locale = barElement.dataset.locale || 'en';

      // Map locale to currency formatting locale
      const localeMap = {
        'it': 'it-IT',
        'en': 'en-GB',
        'fr': 'fr-FR',
        'de': 'de-DE'
      };
      const currencyLocale = localeMap[locale] || 'en-GB';

      const cartTotal = cartData.total_price || 0;
      const remaining = threshold - cartTotal;
      const progressPercentage = Math.min(Math.round((cartTotal / threshold) * 100), 100);

      const amountEl = barElement.querySelector('.cart-free-shipping__amount');
      const progressBar = barElement.querySelector('.cart-free-shipping__progress-bar');
      const percentageEl = barElement.querySelector('.cart-free-shipping__percentage');
      const successEl = barElement.querySelector('.cart-free-shipping__success');
      const messageContainer = barElement.querySelector('.cart-free-shipping__message');

      if (remaining > 0) {
        const formattedRemaining = (remaining / 100).toLocaleString(currencyLocale, {
          style: 'currency',
          currency: 'EUR'
        });

        if (amountEl) {
          amountEl.textContent = messageTemplate.replace('__AMOUNT__', formattedRemaining);
        }

        if (progressBar) {
          // Get the current background color from the element (preserves theme settings)
          const currentColor = window.getComputedStyle(progressBar).backgroundColor;

          // Force a reflow to ensure transition works
          progressBar.offsetHeight;
          progressBar.style.setProperty('width', progressPercentage + '%', 'important');
          // Only set background if it's not already set (preserve inline style from Liquid)
          if (currentColor === 'rgba(0, 0, 0, 0)' || currentColor === 'transparent') {
            progressBar.style.setProperty('background', '#26a0a1', 'important');
          }
          progressBar.style.setProperty('display', 'block', 'important');
        }

        if (percentageEl) {
          percentageEl.textContent = progressTemplate.replace('__PERCENTAGE__', progressPercentage);
        }

        if (messageContainer) messageContainer.style.display = '';
        if (successEl) successEl.style.display = 'none';
      } else {
        if (messageContainer) messageContainer.style.display = 'none';
        if (successEl) successEl.style.display = '';
      }
    }
  };

  // Initialize when script loads
  window.FreeShippingBarUpdater.init();
}
